import React, { useState, useEffect } from "react";
import { useNode } from "@craftjs/core";
import { ASSETS } from "../../../../utils/config";
import TextView from "../../../TextView";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { getSelectedSegment } from "../../../../redux/selectors/segmentBuilderSelectors";
import { handleMenuChange } from "../../../../redux/reducers/segmentBuilder";
import { device } from "../../../../utils/device";
import { useSegmentContext } from "../../../../pages/ViewWheel/SegmentContext";
const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (${device.mobilePortrait}) {
    justify-content: flex-start;
  }
`;

export const EmptyContainer = ({ children }) => {
  const {
    connectors: { connect },
    hasChildren,
  } = useNode((node) => {
    if (node?.data?.name === "EmptyContainerWidget") {
      return { hasChildren: node.data.nodes.length };
    }
  });

  const selectedArc = useSegmentContext();

  // console.log(selectedArc,"selectedArc")

  const dispatch = useDispatch();
  const [showEmptyState, setShowEmptyState] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowEmptyState(hasChildren === 0);
    }, 80);

    return () => clearTimeout(timer);
  }, [hasChildren, selectedArc]);

  const url = window.location.href;
  const isOnViewPage = url.includes("wheel");

  return (
    <div
      ref={connect}
      style={{
        width: "100%",
        minHeight: "calc(100vh - 200px)",
        overflowY: "visible",
        padding: "20px 0px 14px 0px",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        position: "relative",
      }}
    >
      {/* T22.300: an empty Segment with a wallpaper (currentBg 2) shows the
          same copy as one without; the half-white plate keeps it legible. */}
      {!isOnViewPage && showEmptyState ? (
        <Container
          onClick={() => dispatch(handleMenuChange({ num: 3, selectedArc }))}
          // style={{ backgroundColor: 'white' }}
        >
          <div
            style={{
              backgroundColor: "rgba(255,255,255,0.5)",
              borderRadius: 10,
              padding: 30,
              height: "65vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextView
              variant="subtitle"
              color="#0058B8"
              style={{ textAlign: "center" }}
            >
              Click on a Build Block to begin creating
            </TextView>
          </div>
        </Container>
      ) : (
        <div
          style={{
            padding: "5px 0px",
            minHeight: "inherit",
            width: "100%",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};
